import React from 'react';
import PropTypes from 'prop-types';
import NextStep from './NextStep';
import Dictionary from '../../model/Dictionary';
import './MobileBottomNavigation.css';
import ClassNames from 'classnames';

const MobileBottomNavigation = ({ navigation, currentLocation, onClick, nextStep }) => (
  <div
    className={ClassNames(
      { 'first-step': currentLocation && currentLocation.indexOf('flights') !== -1 },
      'mobile-bottom-navigation'
    )}
    id='mobile-bottom-navigation'
  >
    <NextStep
      className={ClassNames(
        { 'first-step': currentLocation && currentLocation.indexOf('flights') !== -1 },
        'mobile-next'
      )}
      label={
        nextStep && nextStep.id && nextStep.id === 'reservationsuccessful' ?
          `${Dictionary.submitReservation}` :
          `${Dictionary.step.next}`
      }
      // nextStep={nextStep ? Dictionary.step[ nextStep.id.toLowerCase() ] : ''}
      step={nextStep}
      onClick={onClick}
      fullWidth
      color='#ffffff'
    />
  </div>
);

MobileBottomNavigation.propTypes = {
  navigation: PropTypes.arrayOf(PropTypes.object),
  currentLocation: PropTypes.string,
  nextStep: PropTypes.object,
  onClick: PropTypes.func,
};

export default MobileBottomNavigation;



// WEBPACK FOOTER //
// ./src/components/navigation/MobileBottomNavigation.js